export default __webpack_public_path__ + "static/media/travel3.35ed4f06.png";